import React from 'react';
import _find from 'lodash/find';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as classesActions from '../../store/classes/actions';
import * as formsActions from '../../store/forms/actions';
import * as fieldsActions from '../../store/fields/actions';
import * as reducers from '../../store/reducers';

import Form from 'Components/Form';
import FlashDialog from 'Components/FlashDialog';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class AddStudentToClassForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAddExistingStudent = this.handleAddExistingStudent.bind(this);
    this.handleIgnoreExistingStudent = this.handleIgnoreExistingStudent.bind(
      this
    );
  }

  handleSubmit(fields, isFormValid) {
    if (isFormValid) {
      const {
        submitForm,
        setFormMessage,
        classId,
        schoolId,
        students,
      } = this.props;
      const existingStudent = _find(
        students,
        s => s.auth_info.username === fields.addStudentToClass__username.value
      );
      if (existingStudent) {
        const message = {
          type: 'info',
          msgId: 'errors.student_already_in_class',
        };
        setFormMessage('addStudentToClass', 'addStudentToClass', message);
      } else {
        submitForm('addStudentToClass', 'addStudentToClass', {
          classId,
          schoolId,
        });
      }
    } else {
      this.props.enableFormReconciliationMode(
        'addStudentToClass',
        'addStudentToClass'
      );
    }
  }

  handleAddExistingStudent(event) {
    event.preventDefault();
    const {
      initializeFields,
      formMessage,
      addExistingStudentToClass,
      classId,
    } = this.props;
    addExistingStudentToClass(formMessage.details.id, classId);
    initializeFields('addStudentToClass', 'addStudentToClass');
  }

  handleIgnoreExistingStudent(event) {
    event.preventDefault();
    const { formMessage, clearFormMessage, toggleReadOnly } = this.props;
    toggleReadOnly('addStudentToClass', 'addStudentToClass', false);
    clearFormMessage('addStudentToClass', 'addStudentToClass');
  }

  render() {
    const duplicateUserDialog = (
      <FlashDialog
        question={
          <ConnectedFormattedMessage id="form.addStudentToClass.dialog_question" />
        }
        yesCallback={this.handleAddExistingStudent}
        noCallback={this.handleIgnoreExistingStudent}
      />
    );

    return (
      <Form
        type="addStudentToClass"
        id="addStudentToClass"
        submitHandler={(fields, isFormValid) =>
          this.handleSubmit(fields, isFormValid)
        }
        formStyle={`add-user`}
        messagePosition="inline-form"
        flashDialog={duplicateUserDialog}
        submitButtonType="add-user"
      />
    );
  }
}

const mapStateToProps = (state, { match: { params } }) => {
  return {
    formMessage: reducers.getFormMessage(state, 'addStudentToClass'),
    classId: params.classId,
    students: reducers.getStudentsInClass(state, params.classId),
    schoolId: reducers.getActiveSchoolId(state),
  };
};

export default withRouter(
  connect(mapStateToProps, {
    ...classesActions,
    ...formsActions,
    ...fieldsActions,
  })(AddStudentToClassForm)
);
